module.exports = __webpack_public_path__ + "static/media/pause.d5cd0055.svg";